<template>
  <div class="material-select multi-select">
    <b-dropdown :text="selectedText" v-if="options" no-caret ref="dropdown">
      <template slot="button-content">
        <div class="add" :class="{ active }">
          <div class="icon">
            <img
              v-show="type === 'teamMembers'"
              src="~@/assets/icons/user-grey.svg"
            />
            <img v-show="type === 'status'" src="~@/assets/icons/status.svg" />
            <img v-show="type === 'type'" src="~@/assets/icons/type.svg" />
            <img
              v-show="type === 'action_type'"
              src="~@/assets/icons/type.svg"
            />
            <img
              v-show="type === 'categoryId'"
              src="~@/assets/icons/category.svg"
            />
            <img
              v-show="type === 'projects'"
              src="~@/assets/icons/category.svg"
            />
          </div>
          <span>{{ selectedText }}</span>
          <img
            class="clear"
            v-if="show_clear"
            src="~@/assets/icons/clear.svg"
            @click.stop.prevent="onChange('All', type)"
          />
        </div>
      </template>

      <input v-if="includeSearch" v-model="search_term" class="search" />
      <img
        v-if="includeSearch && search_term"
        class="clear"
        src="~@/assets/icons/clear.svg"
        @click.stop.prevent="() => (search_term = '')"
      />

      <div v-if="type !== 'teamMembers'" class="teamMembers">
        <div
          class="dropdown-item type-icon"
          :class="{ selected: values && values.includes(option.value) }"
          @click="onChange(option.value, type)"
          v-for="option of options"
          :key="option.value"
        >
          <div
            v-if="type === 'action_type'"
            class="circle icon img"
            :class="option.value.toLowerCase()"
          ></div>
          {{ option.text }}
        </div>
      </div>

      <div v-if="type === 'teamMembers'" class="teamMembers">
        <div
          class="dropdown-item"
          :class="{ selected: values && values.includes(option.value) }"
          @click="onChange(option.value, type)"
          v-for="option of options"
          :key="option.value"
        >
          <span v-if="option.value === 'All'">{{ option.text }}</span>
          <user
            v-if="option.value !== 'All'"
            :users="[option]"
            :text="option.meta"
          />
        </div>
      </div>
    </b-dropdown>
  </div>
</template>

<script>
import User from './User';

export default {
  name: 'MultiSelect',
  data() {
    return {
      active: false,
      search_term: '',
    };
  },
  components: {
    user: User,
  },
  props: {
    values: Array,
    onChange: Function,
    type: String,
    label: String,
    labelPlural: String,
    iconName: String,
    includeSearch: {
      type: Boolean,
      default: false,
    },
    optionFilters: {
      type: Array,
      default: () => ([])
    },
    optionFilterKey: String,
  },
  methods: {
    async get_project_options() {
      if (!Object.keys(this.all_projects).length) {
        await this.$store.dispatch('getAllProjects');
      }
    },
  },
  computed: {
    selectedText() {
      if (!this.values || this.values.includes('All')) {
        return 'All ' + this.labelPlural;
      }

      const label = this.values.length === 1 ? this.label : this.labelPlural;
      return this.values.length + ' ' + label;
    },
    statuses() {
      return [
        { text: 'All statuses', value: 'All' },
        { text: 'Active', value: 'Active' },
        { text: 'Completed', value: 'Completed' },
        { text: 'On hold', value: 'On hold' },
        { text: 'Pipeline', value: 'Pipeline' },
        { text: 'Cancelled', value: 'Cancelled' },
      ];
    },
    types() {
      return [
        { text: 'All types', value: 'All' },
        { value: 'Tender', text: 'Tender' },
        { value: 'Contract Renewal', text: 'Contract Renewal' },
        { value: 'Negotiation', text: 'Negotiation' },
        { value: 'Exit', text: 'Exit' },
        { value: 'Process Review', text: 'Process Review' },
        { value: 'Self-Service', text: 'Self-Service' },
        { value: 'Other', text: 'Other' },
      ];
    },
    action_types() {
      return [
        { text: 'To-do', value: 'To-do' },
        { value: 'Meeting', text: 'Meeting' },
        { value: 'Event', text: 'Event' },
        { value: 'Milestone', text: 'Milestone' },
        { value: 'Contract', text: 'Contract' },
        { value: 'KPI', text: 'KPI Review' },
        { value: 'Sign-off', text: 'Sign-off' },
      ];
    },
    categories() {
      const cats = this.$store.getters.categories;
      const options = Object.keys(cats).map(key => {
        return {
          text: cats[key].name,
          value: cats[key].id,
        };
      });

      return [{ text: 'All categories', value: 'All' }, ...options];
    },
    users() {
      const users = this.$store.getters.users;
      let options = Object.keys(users)
        .map(key => {
          return {
            name: users[key].name,
            initials: users[key].initials,
            meta: users[key].meta,
            value: users[key].id,
          };
        })
        .sort((a, b) => {
          if (a.initials < b.initials) {
            return -1;
          }
          return 1;
        });

      if (this.search_term) {
        const term = this.search_term.toLowerCase();
        options = options.filter(option => {
          return (
            option.name.toLowerCase().includes(term) ||
            option.meta.toLowerCase().includes(term)
          );
        });
      }

      return [{ text: 'All team members', value: 'All' }, ...options];
    },
    options() {
      let options;
      switch (this.type) {
        case 'status':
          options = this.statuses;
          break;
        case 'type':
          options = this.types;
          break;
        case 'action_type':
          options = this.action_types;
          break;
        case 'projects':
          options = this.project_options;
          break;
        case 'categoryId':
          options = this.categories;
          break;
        case 'teamMembers':
        default:
          options = this.users;
      }
      return options.filter(
        (el) => !this.optionFilters.includes(this.optionFilterKey ? el[this.optionFilterKey] : el.value)
      );
    },
    show_clear() {
      if (
        !this.values ||
        (this.values.length === 1 && this.values[0] === 'All')
      )
        return false;
      return true;
    },
    all_projects() {
      return this.$store.getters.all_projects;
    },
    project_options() {
      return Object.keys(this.all_projects)
        .filter(key => key !== this.project_id)
        .map(key => {
          return {
            text: this.all_projects[key].name,
            value: this.all_projects[key].id,
          };
        });
    },
  },
  watch: {
    active() {
      this.get_project_options();
      this.search_term = '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.material-select {
  position: relative;
  padding-top: 15px;
  min-width: auto;

  ::v-deep .btn.btn-secondary,
  .btn.btn-secondary:focus {
    background: transparent !important;
    border-color: transparent !important;
    box-shadow: none !important;
  }

  ::v-deep .dropdown-item {
    margin: 5px 0;
  }

  ::v-deep .dropdown-menu {
    max-height: 247px;
    min-width: 250px;
    overflow-y: auto;
    box-shadow: 0 0 14px 2px rgba(41, 42, 44, 0.09);
    border: 1px solid #e2e5ec !important;
  }

  .placeholder {
    ::v-deep .btn.dropdown-toggle {
      color: #929da9 !important;
    }
  }
}

.multi-select {
  width: 100%;

  ::v-deep .btn.btn-secondary {
    width: 100%;
    padding: 0;
  }

  .add {
    border: 1px solid transparent;
    height: 40px;
    border-radius: 20px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    transition: border 0.2s;

    &:hover {
      border-color: #e2e5ec;

      .icon {
        border-style: solid;
      }
    }

    &.active {
      border-color: #b6bac4;

      .icon {
        border-color: #b6bac4;
        border-style: solid;
      }
    }

    span {
      font-size: 14px;
      margin: 0;
      color: #26292f;
      font-weight: 400;
    }

    .icon {
      margin-right: 8px;
      width: 40px;
      height: 40px;
      position: relative;
      left: -1px;
      border-radius: 20px;
      border: 1px dashed #e2e5ec;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: border 0.2s;

      img {
        max-width: 18px;
        max-height: 20px;
      }
    }
  }
}

.clear {
  position: absolute;
  right: 8px;
  top: 8px;
  padding: 4px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: none;
}

.material-select:hover {
  .clear {
    display: block;
  }
}

::v-deep .user {
  margin: 0 !important;
}

.teamMembers {
  .dropdown-item {
    padding-top: 5px;
    padding-bottom: 5px;
    min-height: 40px;
    display: flex;
    align-items: center;

    span {
      margin-left: 5px;
    }
  }
}

.search {
  width: 100%;
  height: 40px;
  border: none;
  outline: none;
  border-bottom: 1px solid #e2e5ec;
  margin-top: -8px;
  padding: 0 40px 0 50px;
  font-weight: 500;
  font-size: 13px;
  background-repeat: no-repeat;
  background-size: 18px 18px;
  background-position: center left 24px;
  background-image: url(~@/assets/icons/search.svg);
}

.clear {
  position: absolute;
  right: 10px;
  top: 10px;
  display: block;
}

.circle {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  margin-right: 8px;
  color: white;
  background: #26292f;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;

  &.icon {
    background-repeat: no-repeat;
    background-size: 40px 40px;
    background-color: white;
    border: 1px solid #bae3e9;
  }
}
</style>
